<template>
  <a-modal
    v-if="isModalOpen"
    :open="isModalOpen"
    :title="$t('adBlockDetection.title')"
    :footer="null"
    :mask-closable="false"
    :closable="true"
    :keyboard="true"
    :z-index="1000001"
    destroy-on-close
    @cancel="dismissModal">
    <div class="adblock-detected-modal">
      <a-alert
        type="warning"
        show-icon
        :message="$t('adBlockDetection.alert')" />

      <p class="adblock-detected-modal__message">
        {{ $t("adBlockDetection.body") }}
      </p>

      <p class="adblock-detected-modal__message">
        {{ $t("adBlockDetection.instructions") }}
      </p>

      <div class="adblock-detected-modal__actions">
        <a-button data-test="dismiss-ad-block-detected-modal" @click="dismissModal">
          {{ $t("adBlockDetection.actions.dismiss") }}
        </a-button>
        <a-button type="primary" @click="refreshPage">
          {{ $t("adBlockDetection.actions.refresh") }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { computed } from "vue"

import { adBlockDetectionState, dismissAdBlockDetection } from "@/init/adBlockDetection"

const isModalOpen = computed(() => adBlockDetectionState.detected && !adBlockDetectionState.dismissed)

const refreshPage = () => {
  window.location.reload()
}

const dismissModal = () => {
  dismissAdBlockDetection()
}
</script>

<style scoped lang="scss">
.adblock-detected-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.adblock-detected-modal__message {
  margin: 0;
  line-height: 1.6;
}

.adblock-detected-modal__actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
</style>
